import { render, staticRenderFns } from "./addObjectData.vue?vue&type=template&id=78019bb4&scoped=true&"
import script from "./addObjectData.vue?vue&type=script&lang=js&"
export * from "./addObjectData.vue?vue&type=script&lang=js&"
import style0 from "./addObjectData.vue?vue&type=style&index=0&id=78019bb4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78019bb4",
  null
  
)

export default component.exports